import { render } from "./TableList.vue?vue&type=template&id=b09cd39a&scoped=true"
import script from "./TableList.vue?vue&type=script&lang=js"
export * from "./TableList.vue?vue&type=script&lang=js"

import "./TableList.vue?vue&type=style&index=0&id=b09cd39a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b09cd39a"]])

export default __exports__